import { ApiBase } from "../../../../utils/apiBase";
import { CREATEVIEWER, DELETE_VIEWERS_URL } from "../../../../../config/constants";
import { getProjectIdAndOrgId } from "../../../../utils/apiUtils";
import { toast } from "../../../../utils/messageUtils";

// Row level actions for the status viewer modal. Unlike the shared viewer
// actions these report back through the callback on failure too, so the row
// that triggered them can always come out of its loading state.

export const deleteStatusViewer = (payload, callback) => {
  const apiBaseInstance = new ApiBase();
  return () => {
    apiBaseInstance.instance
      .post(DELETE_VIEWERS_URL, { ...payload, ...getProjectIdAndOrgId(payload) })
      .then(() => {
        toast.success("Viewer removed");
        callback && callback(true);
      })
      .catch(() => {
        toast.error("Unable to remove this viewer. Please try again.");
        callback && callback(false);
      });
  };
};

// There is no dedicated resend endpoint yet, so re-posting the invite sends the
// invitation mail again for an already invited viewer.
export const resendStatusViewerInvite = (payload, callback) => {
  const apiBaseInstance = new ApiBase();
  return () => {
    apiBaseInstance.instance
      .post(CREATEVIEWER, { ...payload, ...getProjectIdAndOrgId(payload) })
      .then(() => {
        toast.success("Invitation sent again");
        callback && callback(true);
      })
      .catch(() => {
        toast.error("Unable to resend the invitation. Please try again.");
        callback && callback(false);
      });
  };
};
